var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7069 20.293L17.1679 15.7539C18.3109 14.3059 18.9999 12.483 18.9999 10.5C18.9999 5.813 15.1869 2 10.4999 2C5.81288 2 1.99988 5.813 1.99988 10.5C1.99988 15.187 5.81288 19 10.4999 19C12.4839 19 14.3059 18.312 15.7539 17.168L20.2929 21.707C20.4879 21.902 20.7439 22 20.9999 22C21.2559 22 21.5119 21.902 21.7069 21.707C22.0979 21.316 22.0979 20.684 21.7069 20.293ZM3.99988 10.5C3.99988 6.916 6.91588 4 10.4999 4C14.0839 4 16.9999 6.916 16.9999 10.5C16.9999 14.084 14.0839 17 10.4999 17C6.91588 17 3.99988 14.084 3.99988 10.5Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.fb177608.svg";
export { ForwardRef as ReactComponent };